import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { siteInfo } from "../data/mock";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/chi-siamo", label: "Chi Siamo" },
    { to: "/#corsi", label: "Corsi" },
    { to: "/#categorie", label: "Categorie" },
    { to: "/contatti", label: "Contatti" }
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    if (path.startsWith("/#")) return false;
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-md shadow-md" : "bg-white"}`}>
        <div className="max-w-7xl mx-auto px-6">
          <div className={`flex items-center justify-between transition-all duration-300 ${scrolled ? "h-14" : "h-20"}`}>
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="/logo-apf.png"
                alt="Associazione Progetto Futuro"
                className={`object-contain group-hover:scale-105 transition-all duration-300 ${scrolled ? "h-10" : "h-14"}`}
              />
            </Link>

            <div className="hidden lg:flex items-center gap-8">
              {links.map((link) => (
                link.to.startsWith("/#") ? (
                  <a key={link.to} href={link.to} className="nav-link text-sm font-semibold text-brand-dark hover:text-brand">
                    {link.label}
                  </a>
                ) : (
                  <Link key={link.to} to={link.to} className={`nav-link text-sm font-semibold ${isActive(link.to) ? "text-brand active" : "text-brand-dark hover:text-brand"}`}>
                    {link.label}
                  </Link>
                )
              ))}
            </div>

            <div className="hidden lg:flex items-center gap-3">
              <a href={`tel:${siteInfo.phone}`}>
                <Button className={`bg-brand hover:bg-brand-dark text-white rounded-full px-5 font-semibold shadow-sm hover:shadow-md transition-all duration-300 flex items-center gap-2 ${scrolled ? "h-9 text-sm" : "h-11"}`}>
                  <Phone className={scrolled ? "w-3.5 h-3.5" : "w-4 h-4"} />
                  <span>{siteInfo.phone}</span>
                </Button>
              </a>
            </div>

            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 rounded-md text-brand-dark">
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {isOpen && (
            <div className="lg:hidden py-4 border-t">
              {links.map((link) => (
                link.to.startsWith("/#") ? (
                  <a key={link.to} href={link.to} className="block py-3 text-brand-dark font-semibold">{link.label}</a>
                ) : (
                  <Link key={link.to} to={link.to} className="block py-3 text-brand-dark font-semibold">{link.label}</Link>
                )
              ))}
              <a href={`tel:${siteInfo.phone}`} className="block mt-3">
                <Button className="w-full bg-brand hover:bg-brand-dark text-white rounded-full h-11 font-semibold flex items-center gap-2">
                  <Phone className="w-4 h-4" /> {siteInfo.phone}
                </Button>
              </a>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
